// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const PED_VEN_ITEM_ST = {
  Aberto: 'PED_VEN_ITEM_ST1',
  Confirmado: 'PED_VEN_ITEM_ST2',
  FaturadoParcial: 'PED_VEN_ITEM_ST3',
  FaturadoTotal: 'PED_VEN_ITEM_ST4',
  EncerradoParcial: 'PED_VEN_ITEM_ST6',
  Cancelado: 'PED_VEN_ITEM_ST5',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    PED_VEN_ITEM_ST1: 1,
    PED_VEN_ITEM_ST2: 2,
    PED_VEN_ITEM_ST3: 3,
    PED_VEN_ITEM_ST4: 4,
    PED_VEN_ITEM_ST6: 5,
    PED_VEN_ITEM_ST5: 6
  }
}
